import React, { Component, Fragment } from 'react';
import Loading from 'components/Loading/Loading';
import axios from 'axios';

export default class PromoCodeSpot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      promoCode: '',
      coupon: null,
      isValidating: false,
      isValid: null,
      isVisible: false,
      invalidReason: null,
    };
  }

  componentDidUpdate(prevProps) {
    // Plan changed
    if (
      this.state.coupon &&
      this.props.checkPlan.id &&
      prevProps.checkPlan.id &&
      prevProps.checkPlan.id !== this.props.checkPlan.id
    ) {
      this.checkCouponAppliesToSelectedPlan(this.state.coupon);
    }
  }

  checkCouponAppliesToSelectedPlan(coupon) {
    const { onApplyPromoCode, onClearPromoCode, checkPlan } = this.props;
    const applicablePlanIds = coupon.metadata.plans
      .split(',')
      .map((p) => p.trim());
    if (applicablePlanIds.includes(checkPlan.id)) {
      this.setState({ isValid: true });
      onApplyPromoCode(coupon);
    } else {
      onClearPromoCode();
      this.setState({
        isValid: false,
        invalidReason: 'Not valid for this plan',
      });
    }
  }

  componentDidMount() {
    if (this.props.initialPromoCode) {
      this.setState(
        { isVisible: true, promoCode: this.props.initialPromoCode },
        () => {
          this.validatePromoCode();
        }
      );
    }
  }

  validatePromoCode = async () => {
    const { promoCode, isValid, isValidating } = this.state;
    const { onApplyPromoCode, onClearPromoCode, checkPlan } = this.props;

    if (!isValid && !isValidating) {
      const response = await axios.get(
        `${process.env.REACT_APP_STRIPE_HOST_URL}/coupons/${promoCode}`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_STRIPE_SECRET_KEY}`,
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );
      const coupon = response.data;
      this.setState({ isValidating: false, coupon });
      if (coupon.valid) {
        if (checkPlan && coupon.metadata && coupon.metadata.plans) {
          this.checkCouponAppliesToSelectedPlan(coupon);
        } else {
          this.setState({ isValid: true });
          onApplyPromoCode(coupon);
        }
      } else {
        onClearPromoCode();
        this.setState({ isValid: false, invalidReason: 'Not valid' });
      }
    }
  };

  togglePromoCode = (event) => {
    event.preventDefault();
    const { isVisible } = this.state;
    const { onClearPromoCode } = this.props;

    if (isVisible) {
      onClearPromoCode();
      this.setState({
        isVisible: false,
        promoCode: '',
        isValid: null,
      });
    } else {
      this.setState({
        isVisible: true,
        promoCode: '',
        isValid: null,
      });
    }
  };

  render() {
    const {
      promoCode,
      isValidating,
      isValid,
      isVisible,
      invalidReason,
    } = this.state;

    return (
      <div className="activate-ms-content__promo">
        {isVisible ? (
          <div className="d-flex align-items-center">
            <div className="activate-ms-content__promo-field d-flex align-items-center">
              <input
                value={promoCode}
                className="activate-ms-content__promo-text form-control"
                placeholder="Enter code"
                disabled={isValidating}
                onChange={(event) => this.setState({
                  promoCode: event.target.value,
                  isValid: null,
                })}
              />
              {isValid === true && (
                <img
                  className="d-block"
                  src="/assets/green-check.png"
                  alt="valid"
                />
              )}
            </div>
            {isValidating ? (
              <div className="ml-1">
                <Loading size="small" />
              </div>
            ) : (
              <Fragment>
                <button
                  type="button"
                  className={
                    'activate-ms-content__promo-text activate-ms-content__promo-button btn ' +
                    'btn-primary btn-cursor ml-1'
                  }
                  onClick={this.validatePromoCode}
                >
                  {isValid ? 'Remove' : 'Apply'}
                </button>
                <div
                  className="activate-ms-content__promo-cancel btn-cursor"
                  onClick={this.togglePromoCode}
                />
              </Fragment>
            )}
          </div>
        ) : (
          <a
            className="activate-ms-content__promo-text activate-ms-content__promo-code font-weight-normal"
            href="#"
            onClick={this.togglePromoCode}
          >
            Promo code?
          </a>
        )}

        {isVisible && isValid === false && (
          <div style={{ color: 'red', marginTop: 4 }}>{invalidReason}</div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PromoCodeSpot/index.js